module.exports = __webpack_public_path__ + "media/images/flags/64/Portugal-b70a58591688830586a3686f966973b8.png";